;globalThis["_sentryRouteManifest"] = "{\"dynamicRoutes\":[{\"path\":\"/admin/playbooks/:slug\",\"regex\":\"^/admin/playbooks/([^/]+)$\",\"paramNames\":[\"slug\"],\"hasOptionalPrefix\":false},{\"path\":\"/admin/trace/:envelopeId\",\"regex\":\"^/admin/trace/([^/]+)$\",\"paramNames\":[\"envelopeId\"],\"hasOptionalPrefix\":false},{\"path\":\"/groups/:groupId\",\"regex\":\"^/groups/([^/]+)$\",\"paramNames\":[\"groupId\"],\"hasOptionalPrefix\":false}],\"staticRoutes\":[{\"path\":\"/\"},{\"path\":\"/forgot-password\"},{\"path\":\"/login\"},{\"path\":\"/reset-password\"},{\"path\":\"/signup\"},{\"path\":\"/accounts\"},{\"path\":\"/admin\"},{\"path\":\"/admin/playbooks\"},{\"path\":\"/admin/salesforce-setup\"},{\"path\":\"/dashboard\"},{\"path\":\"/dev/email-preview-test\"},{\"path\":\"/guide\"},{\"path\":\"/inbox\"},{\"path\":\"/insights\"},{\"path\":\"/opportunities\"},{\"path\":\"/personalization\"},{\"path\":\"/profile\"},{\"path\":\"/pulse\"},{\"path\":\"/signals/catalog\"},{\"path\":\"/templates\"},{\"path\":\"/triggers\"},{\"path\":\"/welcome\"},{\"path\":\"/oauth-error\"},{\"path\":\"/status\"}],\"isrRoutes\":[]}";globalThis["_sentryNextJsVersion"] = "16.3.4";globalThis["_sentryRewritesTunnelPath"] = "/monitoring";import * as Sentry from '@sentry/nextjs'
import { SupabaseClient } from '@supabase/supabase-js'
import { currentEnv } from '@handled/shared'
import { tracesSampler } from '@/lib/sentry/sampling'
import { scrubEvent, scrubBreadcrumb } from '@/lib/sentry/before-send'

// Required by @sentry/nextjs to instrument App Router client-side navigations.
// The export is intentionally looked up by Next.js from instrumentation-client.ts.
export const onRouterTransitionStart = Sentry.captureRouterTransitionStart

const supabaseRestPrefix = process.env.NEXT_PUBLIC_SUPABASE_URL
  ? `${process.env.NEXT_PUBLIC_SUPABASE_URL}/rest`
  : undefined

Sentry.init({
  dsn: process.env.NEXT_PUBLIC_SENTRY_DSN,
  environment: currentEnv(),
  enabled: !!process.env.NEXT_PUBLIC_SENTRY_DSN,
  integrations: [
    Sentry.supabaseIntegration({
      supabaseClient: SupabaseClient,
      sendOperationData: false,
    }),
    Sentry.browserTracingIntegration({
      shouldCreateSpanForRequest: (url) => {
        if (!supabaseRestPrefix) return true
        return (
          !url.startsWith(supabaseRestPrefix) ||
          url.startsWith(`${supabaseRestPrefix}/v1/rpc`)
        )
      },
    }),
  ],
  tracesSampler,
  sendDefaultPii: false,
  beforeSend: scrubEvent,
  beforeBreadcrumb: scrubBreadcrumb,
  replaysSessionSampleRate: 0,
  replaysOnErrorSampleRate: 0,
})
